import categoriesApi from '@/services/plataforma/categories';
import { processCategories } from '@/helpers/groupCategories';

const paginate = (list, search, page, limit, ids) => {
  if (ids) {
    return list.filter(item => ids.includes(item.id));
  }
  return list
    .filter(item => item.name.toLowerCase().includes(search.toLowerCase()))
    .slice((page - 1) * limit, page * limit);
};

export default {
  actionGetMyCategories({ commit, state }, { flat, appendDisciplines, isVisible, search, page, limit, ids }) {
    if (state.categories.length) {
      return Promise.resolve({
        categories : paginate(state.categories, search, page, limit, ids),
        totalRows  : state.categories.length
      });
    }

    return categoriesApi.getMyCategories({ flat, appendDisciplines, isVisible })
      .then((response) => {
        const categories = processCategories(response.data.categories);
        commit('SET_CATEGORIES', categories);
        return {
          categories : paginate(categories, search, page, limit, ids),
          totalRows  : categories.length
        };
      });
  }
};
